import { render, staticRenderFns } from "./sider-bar.vue?vue&type=template&id=e9b53874&"
import script from "./sider-bar.vue?vue&type=script&lang=js&"
export * from "./sider-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports